import DSDialog from '../../../design-system/DSDialog';
import DSDialogTitle from '../../../design-system/DSDialogTitle';
import DSDialogContent from '../../../design-system/DSDialogContent';
import DSDialogActions from '../../../design-system/DSDialogActions';
import DSPrimaryButton from '../../../design-system/DSPrimaryButton';
import { UploadLoopSpeck } from './UploadLoopSpec';

type FirstKlydoDialogProps = {
  open: boolean;
  onClose: () => void;
};

const FirstKlydoDialog = ({ open, onClose }: FirstKlydoDialogProps) => {
  return (
    <DSDialog maxWidth="sm" open={open} onClose={onClose}>
      <DSDialogTitle>Welcome to your first Klydo!</DSDialogTitle>
      <DSDialogContent>
        <UploadLoopSpeck />
      </DSDialogContent>
      <DSDialogActions>
        <DSPrimaryButton onClick={onClose}>Got it</DSPrimaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};

export default FirstKlydoDialog;
